import router from "@/router";
import { APIService, AXIOS_CLIENT } from "@/config/api-service-client.js";
import { DEFAULT_LOCALE } from "@/config/variables.js";

const getDefaultState = () => {
  return {
    user: {},
    access_token:
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("access_token") ||
      null,
    access_expires_in:
      sessionStorage.getItem("access_expires_in") ||
      localStorage.getItem("access_expires_in") ||
      null,

    watchersForCurrentUser: [],

    loginTimedOut: false,
    loginTimedOutAllowRefresh: false,
  };
};

export default {
  state: getDefaultState(),
  mutations: {
    setUser(state, data) {
      localStorage.setItem("login", data?.login);
      sessionStorage.setItem("login", data?.login);
      localStorage.setItem("access_level", data?.access_level);
      sessionStorage.setItem("access_level", data?.access_level);

      state.user = data;
    },
    logOutUser(state, user) {
      delete AXIOS_CLIENT.defaults.headers.common["Authorization"];
      const USER = user;
      console.log("USER", USER);
      const checkRouteName = router.currentRoute.name === "PageLogin";

      Object.assign(state, getDefaultState());
      if (!checkRouteName) {
        router.push({
          name: "PageLogin",
          params: {
            client_name: USER
              ? USER
              : router?.currentRoute?.value?.params?.client_name,
          },
        });
      }
    },

    clearStorages() {
      delete AXIOS_CLIENT.defaults.headers.common["Authorization"];
      const selectedStudy = localStorage.getItem("selected-study");

      localStorage.clear();
      sessionStorage.clear();
      if (selectedStudy) {
        sessionStorage.setItem("selected-study", selectedStudy);
        localStorage.setItem("selected-study", selectedStudy);
      }
    },

    setTokens(state, data) {
      const ACCESS_TOKEN = data.access_token;
      const ACCESS_EXPIRES_IN = data.access_expires_in;

      const CALC_ACCESS_EXPIRES_IN =
        +Math.floor(new Date().getTime() / 1000) + ACCESS_EXPIRES_IN;

      state.access_token = ACCESS_TOKEN;

      state.access_expires_in = CALC_ACCESS_EXPIRES_IN;

      sessionStorage.setItem("access_token", ACCESS_TOKEN);
      sessionStorage.setItem("access_expires_in", CALC_ACCESS_EXPIRES_IN);

      localStorage.setItem("access_token", ACCESS_TOKEN);
      localStorage.setItem("access_expires_in", CALC_ACCESS_EXPIRES_IN);

      AXIOS_CLIENT.defaults.headers.common["Authorization"] =
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token");
    },

    mutate_login_timed_out(state, value) {
      state.loginTimedOut = value;
    },
    set_watchers_for_current_user(state, value) {
      state.watchersForCurrentUser = value;
    },
  },
  actions: {
    async getToken(_, data) {
      const sendData = {
        ...data,
      };
      if (!sendData.client_name) {
        sendData.client_name = router?.currentRoute?.value?.params?.client_name;
      }
      try {
        console.log("sendData:", sendData);
        const data = await APIService.post("/login", sendData);
        return data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async setUserData(ctx) {
      let userDataPath = `/users/me`;
      try {
        const user = await APIService.get(userDataPath);

        await ctx.commit("setUser", user);
        return user;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async getUserInfo(ctx, tokenResponse) {
      try {
        if (tokenResponse) {
          ctx.commit("setTokens", tokenResponse);
        }
        await ctx.dispatch("setUserData");
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async stayLogIn(ctx) {
      if (sessionStorage.access_token || localStorage.access_token) {
        try {
          await ctx.dispatch("setUserData");
        } catch (e) {
          if (e?.response?.status === 401) ctx.dispatch("logOut");
          console.log(e);
          throw e;
        }
      }
    },
    async logOut(ctx) {
      const USER =
        localStorage.getItem("client_name") ||
        sessionStorage.getItem("client_name");

      await ctx.commit("clearStorages");
      await ctx.commit("logOutUser", USER);
    },
    async resetPassword(ctx, userData) {
      let sendLocale = ctx.getters.get_curr_locale;
      if (sendLocale === DEFAULT_LOCALE) {
        sendLocale = "";
      }
      try {
        await APIService.post("api/auth/reset-password", {
          login: userData.login,
          locale: sendLocale,
        });
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async setNewPassword(ctx, data) {
      try {
        await APIService.post(
          `/auth/reset-password/${data.reset_password_token}`,
          {
            password: data.formData.password,
            confirm_password: data.formData.confirm_password,
          }
        );
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    // Get watchers of user
    async setWatchersForCurrentUser(ctx, payload) {
      const { target_type } = payload;
      let path = `/api/subscriptions?userId=${ctx.getters.getCurrentUserID}&targetType=${target_type}`;
      try {
        const resp = await APIService.get(path);
        await ctx.commit("set_watchers_for_current_user", resp);
        return resp;
      } catch (e) {
        console.log("setWatchersForCurrentUser error", e);
        throw e;
      }
    },
  },

  getters: {
    currentUser: (state) => state,
    getCurrentUserID: (state) => state.user.id,
    getCurrentUserLocale: (state) => state.user.locale,
    getWatchersForCurrentUser: (state) => state.watchersForCurrentUser,

    loginTimedOut: (state) => state.loginTimedOut,
    getCurrentUserOrganization: (state) => state.user.organization,
    get_access_token: (state) => state.access_token,
    get_curr_locale: (state) => state.currLocale,
    cwsInfo: (state) => state.cwsInfo,
  },
};
